import { isGroupDetails } from "@custom-types/type-guards";
import { groupsAdapter } from "@store/groups/groups-slice";
/** Update a member role in group store by updating it from members array attribute of the group */
export function updateMemberRoleInGroupStore(state, result) {
  const group = groupsAdapter.getSelectors().selectById(state, result.groupId);

  // If the groups is in the store update the member role
  if (group && isGroupDetails(group)) {
    groupsAdapter.updateOne(state, {
      id: group.id,
      changes: {
        members: group.members?.map(member => {
          if (member.identity === result.userIdentity) {
            return {
              ...member,
              role: result.role
            };
          }
          return member;
        })
      }
    });
  }
}

/**
 * Removes locally a member from a group, by removing it from members array
 * attribute of the group if members are available.
 */
export function removeLocalMemberFromGroup(state, result) {
  const group = groupsAdapter.getSelectors().selectById(state, result.groupId);
  if (group && isGroupDetails(group)) {
    const newMembers = group.members?.filter(member => member.identity !== result.member.identity);
    groupsAdapter.updateOne(state, {
      id: group.id,
      changes: {
        members: newMembers
      }
    });
    if (newMembers.length === 0) {
      groupsAdapter.removeOne(state, result.groupId);
      result.onGroupRemoved();
    }
  }
}